export default "__VITE_PUBLIC_ASSET__84bca7ed__"